import React, { useState } from 'react';
import moment from 'moment';
import { View } from 'react-native';
import { Calendar } from 'react-native-calendars';
import { AntDesign } from '@expo/vector-icons';

interface Props {
  value: string;
  setFieldValue: (data: string) => void;
  availableDates: string[];
  setOtherFieldValues: any;
  style: any;
  onDayPress?: () => void;
}

const CalendarArea: React.FC<Props> = ({
  value: _value,
  setFieldValue,
  availableDates,
  setOtherFieldValues,
  onDayPress,
}: Props) => {
  const [selected, setSelected] = useState('');

  const generateMarkedDates = (dates: string[]): Record<string, any> => {
    if (dates === null || dates.length <= 0) {
      dates = [new Date().toISOString()];
    }

    const startDate = moment(dates[0]).subtract(2, 'months').startOf('month');
    const endDate = moment(dates[0]).add(1, 'months').endOf('month');

    const wholeDates: string[] = [];

    let cd = startDate;
    while (cd.isSameOrBefore(endDate)) {
      wholeDates.push(cd.format('YYYY-MM-DD'));
      cd = cd.add(1, 'days');
    }
    const markedDates: Record<string, any> = {};

    for (let i = 0; i < wholeDates.length; i++) {
      const dateString = wholeDates[i];
      if (dates.includes(dateString)) {
        if (dateString === selected) {
          markedDates[dateString] = {
            selected: true,
            disableTouchEvent: true,
          };
        } else markedDates[dateString] = { disabled: false };
      } else {
        markedDates[dateString] = {
          disabled: true,
          disableTouchEvent: true,
        };
      }
    }

    return markedDates;
  };

  const currentDate = moment().format('YYYY-MM-DD');

  return (
    <View>
      <Calendar
        onDayPress={(day) => {
          setSelected(day.dateString);
          setFieldValue(day.dateString);
          setOtherFieldValues();
          if (onDayPress !== undefined) {
            onDayPress();
          }
        }}
        markingType={'custom'}
        markedDates={generateMarkedDates(availableDates)}
        renderArrow={(direction) => (
          <View>
            {direction === 'left' ? (
              <AntDesign name="left" size={24} color="black" />
            ) : (
              <AntDesign name="right" size={24} color="black" />
            )}
          </View>
        )}
        minDate={currentDate}
        maxDate={
          availableDates.length > 0
            ? availableDates?.sort((a, b) => (a > b ? -1 : 1))[0]
            : new Date().toDateString()
        }
      />
    </View>
  );
};

export default CalendarArea;
